import { buildAnimatedTitle } from "../../HeroTitleAnimation.js";
import { appRoute } from "../../../config/paths.js";

function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/"/g, "&quot;");
}

/**
 * Shared Privacy / Terms document layout.
 * @param {{
 *   eyebrow: string,
 *   title: string,
 *   subtitle: string,
 *   lastUpdated: string,
 *   sections: Array<{ heading: string, body: string }>,
 *   related?: { label: string, href: string, linkLabel: string },
 *   homeHref?: string,
 * }} page
 */
export function createLegalDocumentSection(page) {
  const section = document.createElement("section");
  section.id = "legal";
  section.className = "section legal-doc";

  const related = page.related
    ? `<p class="legal-doc__related reveal">
        ${escapeHtml(page.related.label)}
        <a href="${page.related.href}">${escapeHtml(page.related.linkLabel)}</a>
      </p>`
    : "";

  section.innerHTML = `
    <div class="legal-doc__wash" aria-hidden="true"></div>
    <div class="section__inner legal-doc__inner">
      <nav class="legal-doc__crumb reveal" aria-label="Breadcrumb">
        <a href="${page.homeHref || appRoute("hero")}">Home</a>
        <span aria-hidden="true">/</span>
        <span>${escapeHtml(page.title)}</span>
      </nav>

      <header class="legal-doc__header">
        <p class="legal-doc__eyebrow reveal">${escapeHtml(page.eyebrow)}</p>
        <h1 class="legal-doc__title reveal">${buildAnimatedTitle([{ text: page.title, highlight: null }])}</h1>
        <p class="legal-doc__subtitle reveal">${escapeHtml(page.subtitle)}</p>
        <p class="legal-doc__meta reveal">Last updated: ${escapeHtml(page.lastUpdated)}</p>
      </header>

      <article class="legal-doc__article">
        ${page.sections
          .map(
            (block, index) => `
          <section class="legal-doc__block reveal" style="--delay: ${(index * 0.04).toFixed(2)}s">
            <h2>${escapeHtml(block.heading)}</h2>
            <p>${escapeHtml(block.body)}</p>
          </section>
        `
          )
          .join("")}
      </article>

      ${related}
    </div>
  `;

  return section;
}
